if (!customElements.get('flash-notice')) {
    let flashNotice;
    let flashError;
    let wrapperNode;
    let templateNode;
    let hiddenFlashOffset;
    const CLASSES = {
        CONTAINER: 'flash-container',
        FLASH: 'flash-message',
        FLASH_CONTENT: 'flash-message__content',
        CLOSE_BUTTON: 'flash-message__close-button',
        ERROR: 'flash-message--error',
        ANIMATE_IN: 'flash-message--is-animating-in',
        ANIMATE_OUT: 'flash-message--is-animating-out',
        ANIMATE_DOWN: 'flash-message--is-animating-down',
    };
    const ATTRIBUTES = {
        STYLE: 'style',
        CSS_VARIABLE: '--element-height',
        ROLE: 'role',
        ROLE_ALERT: 'alert',
        ROLE_STATUS: 'status',
    };
    const EVENTS = {
        CLICK: 'click',
        ANIMATION_END: 'animationend',
        FLASH_HIDING: 'flash:hiding',
        DOM_READY: 'DOMContentLoaded',
    };

    customElements.define(
        'flash-notice',
        class Flash extends HTMLElement {
            constructor(message, options = { isError: false, noticeDuration: 4000 }) {
                super();
                this.flash_messages = [];
                this.wrapperNode = this.querySelector(`.${CLASSES.CONTAINER}`);
                this.templateNode = this.querySelector(`.${CLASSES.FLASH}`);
                this.message = message;
                this.node = this.templateNode.cloneNode(true);
                this.isError = options.isError;
                this.contentNode = this.node.querySelector(`.${CLASSES.FLASH_CONTENT}`);
                this.closeButton = this.node.querySelector(`.${CLASSES.CLOSE_BUTTON}`);
                this.wrapperNode = wrapperNode;
                this.lastFocusedElement = document.activeElement || document.body;
                this.timeout = null;

                if (this.isError) {
                    this.duration = null;
                } else {
                    this.duration = options.noticeDuration;
                }

                document.addEventListener(EVENTS.FLASH_HIDING, (event) => {
                    const hiddenMessage = {
                        index: event.detail.index,
                        height: event.detail.height,
                    };
                    this.removeMessage(hiddenMessage);
                });
            }

            removeMessage(hiddenMessage) {
                if (this.flash_messages[hiddenMessage?.index]) {
                    this.shiftMessageDown(this.flash_messages[hiddenMessage?.index].node, hiddenMessage.height);
                    delete this.flash_messages[hiddenMessage?.index];
                }

                if (hiddenMessage.index !== -1) {
                    this.flash_messages.splice(hiddenMessage.index, 1);
                }
            }

            shiftMessageDown(node, height) {
                node.classList.add(CLASSES.ANIMATE_DOWN);
                node.style.setProperty(ATTRIBUTES.CSS_VARIABLE, height);
                node.addEventListener(EVENTS.ANIMATION_END, () => {
                    node.removeAttribute(ATTRIBUTES.STYLE);
                    node.classList.remove(CLASSES.ANIMATE_DOWN);
                });
            }

            setHiddenFlashOffset(node) {
                const height = node.offsetHeight;
                if (node) {
                    const siblingMargin = (parseFloat(
                        window.getComputedStyle(node.nextSibling ?? node).marginBottom
                    ));
                    hiddenFlashOffset = `${height + siblingMargin}px`;
                }
            }

            show() {
                this.flash_messages.push(this);
                this.closeButton.addEventListener(EVENTS.CLICK, () => {
                    this.hide();
                });
                if (this.isError) {
                    this.node.classList.add(CLASSES.ERROR);
                    this.contentNode.setAttribute(ATTRIBUTES.ROLE, ATTRIBUTES.ROLE_ALERT);
                } else {
                    this.contentNode.setAttribute(ATTRIBUTES.ROLE, ATTRIBUTES.ROLE_STATUS);
                    this.timeout = setTimeout(() => this.hide(), this.duration);
                }

                if (!this.wrapperNode) {
                    this.wrapperNode = this.querySelector(`.${CLASSES.CONTAINER}`);
                }
                this.contentNode.textContent = this.message;
                this.wrapperNode.appendChild(this.node);
                this.contentNode.focus();
                this.node.classList.add(CLASSES.ANIMATE_IN);
                this.node.addEventListener(EVENTS.ANIMATION_END, () => {
                    this.node.classList.remove(CLASSES.ANIMATE_IN);
                });
            }

            hide() {
                this.setHiddenFlashOffset(this.node);
                document.dispatchEvent(new CustomEvent(EVENTS.FLASH_HIDING, {
                    detail: {
                        index: this.flash_messages.indexOf(this),
                        height: hiddenFlashOffset,
                    },
                }));
                this.node.classList.add(CLASSES.ANIMATE_OUT);
                this.node.addEventListener(EVENTS.ANIMATION_END, () => {
                    this.node.classList.remove(CLASSES.ANIMATE_OUT);
                    if (this.wrapperNode?.contains(this.node)) {
                        this.wrapperNode?.removeChild(this.node);
                    } else {
                        this.node.remove();
                    }
                    if (this.wrapperNode?.children.length) {
                        this.wrapperNode.lastChild.querySelector(`.${CLASSES.FLASH_CONTENT}`).focus();
                    } else {
                        this.lastFocusedElement.focus();
                    }
                });

                this.node.dispatchEvent(new CustomEvent(EVENTS.ANIMATION_END));
            }

        }
    );
}
